import { Link, createFileRoute } from "@tanstack/react-router";
import { ServerGroupsPanel } from "@/components/games/ServerGroupsPanel";

export const Route = createFileRoute("/games/$gameId/server_groups")({
  component: ServerGroupsRoute,
});

function ServerGroupsRoute() {
  const { gameId } = Route.useParams();
  return (
    <div className="space-y-4">
      <Link
        to="/games/$gameId"
        search={{ tab: "servers" }}
        params={{ gameId }}
        className="text-xs underline"
      >
        返回游戏配置
      </Link>
      <ServerGroupsPanel gameID={gameId} />
    </div>
  );
}
